/**
 * @description 此文件为公共常量文件，编辑删除请多注意添加注释并悉知其他地方是否使用，
 */
import ApiDocConst from '@/views/apiDoc/const';
import ControlConst from '@/views/control/const';

const constants = {};
export default Object.assign({}, constants, ApiDocConst, ControlConst);
